module.exports = __webpack_public_path__ + "img/pin-affiliate.b61e0c79.png";